import { useEffect } from "react";
import { useLocation } from "react-router-dom";

function ScrollToTop() {
  const { pathname, hash } = useLocation();

  useEffect(() => {
    if (!hash) {
      // normal navigation
      window.scrollTo({ top: 0, left: 0 });
      return;
    }

    // hash navigation (wait until element exists)
    let tries = 0;
    const maxTries = 20;

    const scrollToHash = () => {
      const id = hash.replace("#", "");
      const el = document.getElementById(id);

      if (el) {
        el.scrollIntoView({ behavior: "smooth" });
      } else if (tries < maxTries) {
        tries++;
        requestAnimationFrame(scrollToHash);
      }
    };

    scrollToHash();
  }, [pathname, hash]);

  return null;
}

export default ScrollToTop;
